module.exports = __webpack_public_path__ + "img/KH.61093917.svg";